var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTragOv9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2171 17.8486C27.5494 12.804 26.1337 7.97884 23.9699 3.37319C22.9752 1.33315 20.098 -0.234794 17.8485 0.0290504C12.8039 0.69678 7.97878 2.11252 3.37313 4.27627C1.33309 5.27101 -0.234854 8.14821 0.0289916 10.3977C0.708057 15.5493 2.17207 20.4706 4.41044 25.1596C5.34391 27.0421 7.99553 28.4907 10.084 28.2591C15.2437 27.6077 20.1758 26.1807 24.873 23.97C26.913 22.9752 28.481 20.098 28.2171 17.8486Z",
    fill: "#90C040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTragOv9);
export default __webpack_public_path__ + "static/media/trag-ov-9.56154f8924fe2fdce24afd520d8c1feb.svg";
export { ForwardRef as ReactComponent };